/* eslint-disable no-unused-vars */
import { useSelector } from 'react-redux';

import config from '../config';
//import GetSellerConfig from './GetSellerConfig';
//const { sellerComponentBackgroundColor } = GetSellerConfig();

//const { 
// seller, sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// sellerColorDark, sellerColorMedium, sellerColorLight, 
// sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
// sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
// sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber, sellerShoppingTerm, 
// sellerEventParts, sellerClothColors, sellerMinGuestCount, sellerServiceTypes, sellerPlaceSettings, sellerOtherEventOptionsChoices,
// sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
// sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
// sellerPersonalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames, sellerChatOfflineMessage,

// sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
// sellerBoolShowSiteSamplesMenus, sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials, 
// sellerBoolShowSitePayments, sellerBoolShowSiteRating, sellerBoolShowCuisineType,
// sellerBoolShowCookingMethods, sellerBoolShowHoliday, sellerBoolShowSiteChatOnline, sellerBoolShowQuantities
// } = GetSellerConfig();

//style={{ backgroundColor: sellerSecondaryColor1 + sellerColorSuffixMedium
//style={{ backgroundColor: `${secondaryColor}${suffixMedium}`

const GetSellerConfig = () => {
    const sellerEnvironment = config.STR_ENVIRONMENT
    const { seller } = useSelector(state => state.seller);

    const sellerId = seller._id;
    const sellerPrimaryColor1 =                 seller?.frontEndPrimaryColor1;
    const sellerPrimaryColor2 =                 seller?.frontEndPrimaryColor2;
    const sellerSecondaryColor1 =               seller?.frontEndSecondaryColor1;
    const sellerSecondaryColor2 =               seller?.frontEndSecondaryColor2;

    const sellerArrHexOpacityColorSuffixes =    seller?.hexOpacityColorSuffixes?.split(';') || []; // 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
    const sellerColorSuffixDark =               sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const sellerColorSuffixMedium =             sellerArrHexOpacityColorSuffixes[1] || '80';
    const sellerColorSuffixLight =              sellerArrHexOpacityColorSuffixes[2] || '1A';
    const sellerComponentBackgroundColor =      sellerEnvironment === 'Dev' ? '#00ff001A' : sellerSecondaryColor1 + sellerColorSuffixMedium;
    
    const sellerColorDark =                     sellerPrimaryColor1 + sellerColorSuffixDark;
    const sellerColorMedium =                   sellerPrimaryColor1 + sellerColorSuffixMedium;
    const sellerColorLight =                    sellerPrimaryColor1 + sellerColorSuffixLight;
    
    const sellerShopName =                      seller?.shopName;
    const sellerStripePaymentMode =             seller?.stripePaymentMode;
    const sellerOtherWebsiteURL1 =              seller?.otherWebsiteURL1;
    const sellerOtherWebsiteName1 =             seller?.otherWebsiteName1;
    const sellerOtherWebsiteURL2 =              seller?.otherWebsiteURL2;
    const sellerOtherWebsiteName2 =             seller?.otherWebsiteName2;
    const sellerProductTerm =                   seller?.productTerm;
    const sellerProductPluralTerm =             seller?.productPluralTerm;
    const sellerCompanyPhoneNumber =            seller?.phoneNumber;
    const sellerCompanyLogo =                   seller?.logoImage;
    const sellerSellerImage =                   seller?.sellerImage;        
    const sellerBeforeYouRegister1 =            seller?.beforeYouRegister1;
    const sellerPhoneNumber =                   seller?.phoneNumber
    const sellerShoppingTerm =                  seller?.shoppingTerm
    const sellerEventParts =                    seller?.eventParts
    const sellerClothColors =                   seller?.clothColors
    const sellerMinGuestCount =                 seller?.minGuestCount
    const sellerServiceTypes =                  seller?.serviceTypes
    const sellerPlaceSettings =                 seller?.placeSettings
    const sellerOtherEventOptionsChoices =      seller?.otherEventOptionsChoices
    
    // address1:                               
    // address2:                               { type: String, required : false },
    // city:                                   { type: String, required : false },
    // sellerState:                            { type: String, required : false },
    // zipCode:                                { type: String, required : false }, 
    // phoneNumber:                            { type: String, required : false },
    // emailAddress:                           { type: String, required : false }, 
    // contactPerson:                          { type: String, required : false },  

    const sellerCompanyEmailAddress =                   seller?.emailAddress;
    const sellerCompanyKosherSupervision1 =             seller?.kosherSupervision1;
    const sellerCompanyKosherSupervision2 =             seller?.kosherSupervision2;
    const sellerMainIngredientPluralTerm =              seller?.mainIngredientPluralTerm;
    const sellerTaglineTop1 =                           seller?.taglineTop1;
    const sellerTaglineTop2 =                           seller?.taglineTop2;
    const sellerPersonalServiceTagLine =                seller?.personalServiceTagLine;
    const sellerMarketingLine1 =                        seller?.marketingLine1;
    const sellerHolidayHeader =                         seller?.holidayHeader;
    const sellerOwnerNames =                            seller?.ownerNames;
    const sellerChatOfflineMessage =                    seller?.chatOfflineMessage

    const sellerBoolShowSiteWishList =                      seller?.isVisibleSiteWishlist === 'Show';
    const sellerBoolShowSiteChat =                          seller?.isVisibleSiteChat === 'Show';
    const sellerBoolShowGalleryImages =                     seller?.isVisibleGalleryImages === 'Show';
    const sellerBoolShowSocialMedia =                       seller?.isVisibleSiteSocialMedia === 'Show';
    const sellerBoolShowSiteSamplesMenus =                  seller?.isVisibleSiteSamplesMenus  === 'Show'        // ? true : false
    const sellerBoolShowSitePackages =                      seller?.isVisibleSitePackages  === 'Show'                // ? true : false
    const sellerBoolShowCustomerTestimonials =              seller?.isVisibleCustomerTestimonials  === 'Show' // ? true : false
    const sellerBoolShowSitePayments =                      seller?.isVisibleSitePayments === 'Show'         //? true : false
    const sellerBoolShowSiteRating =                        seller?.isVisibleSiteRating === 'Show' //? true : false
    const sellerBoolShowCuisineType   =                     seller?.isVisibleSiteCuisineType === 'Show'
    const sellerBoolShowCookingMethods =                    seller?.isVisibleSiteCookingMethods  === 'Show';
    const sellerBoolShowHoliday =                           seller?.isVisibleSiteHoliday         === 'Show';
    const sellerBoolShowKosher =                            seller?.isVisibleSiteKosher         === 'Show';
    const sellerBoolShowSiteChatOnline =                    seller?.isVisibleSiteChatOnline === 'Online' // ? true : false
    const sellerBoolShowQuantities =                        seller?.isVisibleSiteProductQuantities === 'Show'
    const sellerCateringLocationList =                      seller?.cateringLocationList
    const sellerBoolRestrictCustomerToCateringLocations =   seller?.restrictCustomerToCateringLocations
    const sellerEventTypeList =                             seller?.eventTypeList

    // const kosherLogo1 = KOSHER_LOGO_MAP[s.kosherSupervision1] ?? '';
    // const kosherLogo2 = KOSHER_LOGO_MAP[s.kosherSupervision2] ?? '';

    return {
        seller, sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo, sellerSellerImage, 
        sellerBeforeYouRegister1, sellerPhoneNumber, sellerShoppingTerm, sellerEventParts, 
        sellerClothColors, sellerMinGuestCount, sellerServiceTypes, sellerPlaceSettings, sellerOtherEventOptionsChoices,
        sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        sellerPersonalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames, sellerChatOfflineMessage,

        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
        sellerBoolShowSiteSamplesMenus, sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials, sellerBoolShowSitePayments,
        sellerBoolShowSiteRating, sellerBoolShowCuisineType, sellerBoolShowCookingMethods, sellerBoolShowHoliday, sellerBoolShowKosher, 
        sellerBoolShowSiteChatOnline, sellerBoolShowQuantities, sellerCateringLocationList, sellerBoolRestrictCustomerToCateringLocations,
        sellerEventTypeList
    };
};

export default GetSellerConfig;
